/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import JSG from '@cedalo/jsg-ui';
import {graphManager} from '../../../GraphManager';
import Divider from '@mui/material/Divider';
import DialogButton from '../../utils/DialogButton';

export default class InsertCellContentDialog extends React.Component {
	static propTypes = {
		open: PropTypes.bool.isRequired,
		close: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props);

		this.state = {
			type: 'all',
		};
	}

	handleCancel = () => {
		this.props.close();
	};

	handleClose = () => {
		this.props.close();

		const sheetView = graphManager.getActiveSheetView();
		if (sheetView) {
			const selection = sheetView.getOwnSelection();
			if (selection.hasSelection()) {
				sheetView.pasteFromClipboard(
					graphManager.getGraphEditor().getGraphViewer(),
					selection.getAt(0).copy(),
					JSG.clipSheet.data,
					this.state.type,
				);
			}
		}
	};

	render() {
		if (!this.props.open) {
			return null
		}
		return (
			<div>
				<Dialog open>
					<DialogTitle>
						<FormattedMessage
							id="DialogInsertCellContent.Title"
							defaultMessage="Insert Cell Content"
						/>
					</DialogTitle>
					<DialogContent
						style={{
							minWidth: '200px',
						}}
					>
						<RadioGroup
							name="type"
							value={this.state.type}
							onChange={(event, state) => { this.setState({ type: state }); }}
							style={{
								marginTop: '20px',
							}}
						>
							<FormControlLabel
								value="all"
								control={<Radio />}
								label={<FormattedMessage
									id="DialogInsertCellContent.Complete"
									defaultMessage="Complete"
								/>}
							/>
							<FormControlLabel
								value="formulas"
								control={<Radio />}
								label={<FormattedMessage
									id="DialogInsertCellContent.Formulas"
									defaultMessage="Formulas"
								/>}
							/>
							<FormControlLabel
								value="values"
								control={<Radio />}
								label={<FormattedMessage
									id="DialogInsertCellContent.Values"
									defaultMessage="Values"
								/>}
							/>
							<FormControlLabel
								value="formats"
								control={<Radio />}
								label={<FormattedMessage
									id="DialogInsertCellContent.Formats"
									defaultMessage="Formats"
								/>}
							/>
						</RadioGroup>
					</DialogContent>
					<Divider />
					<DialogActions>
						<DialogButton
							margin
							onClick={this.handleCancel}
						>
							<FormattedMessage
								id="Dialog.Cancel"
								defaultMessage="Cancel"
							/>
						</DialogButton>
						<DialogButton
							margin
							onClick={this.handleClose}
							defaultButton
						>
							<FormattedMessage
								id="Dialog.OK"
								defaultMessage="OK"
							/>
						</DialogButton>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}
